export interface IDropdownFilterMenuLogicParam {
  isActive: boolean;
  containerClassName: string;
  whenActiveContainerClassName: string;
}
export interface IDropdownFilterMenuLogic {
  useContainerClassName: string;
}

export const useDropdownFilterMenuLogic = ({isActive, containerClassName, whenActiveContainerClassName}: IDropdownFilterMenuLogicParam): IDropdownFilterMenuLogic => {
  const containerClasses: string[] = [
    containerClassName,
  ];
  if (isActive) {
    containerClasses.push(whenActiveContainerClassName);
  }
  const useContainerClassName = containerClasses.join(` `);
  return {
    useContainerClassName,
  };
}
